import * as React from 'react'
import BaseIcon from 'react-icon-base'

const NotificationIcon = props => (
  <BaseIcon width="16px" height="20px" viewBox="0 0 16 20" {...props}>
    <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="notifications" transform="translate(-8.000000, -7.000000)" fill="#C4CCD5">
        <path
          d="M17,24 C17,24.552 16.552,25 16,25 C15.448,25 15,24.552 15,24 L15,23 L17,23 L17,24 Z M22,19 L22,15 C22,11.447 19.632,9.475 17,9.079 L17,7 L15,7 L15,9.079 C12.368,9.475 10,11.447 10,15 L10,19 C10,20.105 9.105,21 8,21 L8,23 L13,23 L13,24 C13,25.657 14.343,27 16,27 C17.657,27 19,25.657 19,24 L19,23 L24,23 L24,21 C22.895,21 22,20.105 22,19 L22,19 Z"
          id="Icon---Bell-Non-Active"
        />
      </g>
    </g>
  </BaseIcon>
)

export default NotificationIcon
